import { RECEIVED_INSTRUMENT_TREND_MESSAGE } from '../../actions';
export default function instrumentsTrendReducer(state, action) {
    switch (action.type) {
        case RECEIVED_INSTRUMENT_TREND_MESSAGE:
            return Object.assign(Object.assign({}, state), { instrumentsTrend: Object.assign(Object.assign({}, state.instrumentsTrend), { [action.payload.symbol]: action.payload.trend }) });
        default:
            return state;
    }
}
